module.exports = __webpack_public_path__ + "img/mechanical_engineering_splash.294369bb.jpg";